import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: "root",
})
export class GoogleMapsLoaderService {
    private loadingPromise: Promise<void> | null = null;
    private script: HTMLScriptElement | null = null;

    loadGoogleMaps(): Promise<void> {
        if (this.loadingPromise) {
            return this.loadingPromise;
        }

        this.loadingPromise = new Promise((resolve, reject) => {
            this.script = document.createElement("script");
            this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsApiKey}&loading=async`;
            this.script.async = true;
            this.script.defer = true;

            this.script.onload = () => {
                resolve();
            };

            this.script.onerror = (error) => {
                reject(error);
                this.loadingPromise = null;
            };

            document.body.appendChild(this.script);
        });

        return this.loadingPromise;
    }

    removeScript(): void {
        if (this.script && document.body.contains(this.script)) {
            document.body.removeChild(this.script);
            this.script = null;
            this.loadingPromise = null;
            delete (window as any).google;
        }
    }
}
